// extracted by mini-css-extract-plugin
export default {"chatContainer":"style_chatContainer__8qnwC","floatingWrapper":"style_floatingWrapper__coB0a","floatingContainer":"style_floatingContainer__Lza7V"};